"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var TextField_1 = __importDefault(require("../../TextField"));
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {},
        radios: {
            display: 'flex',
        },
        formControl: {
            margin: theme.spacing(3),
        },
        customTextField: {
            maxWidth: 60,
        },
        textarea: {
            marginTop: theme.spacing(1),
            padding: theme.spacing(1),
        },
    });
});
var DeckImportFromQuizlet = function (_a) {
    var values = _a.values, onFieldChange = _a.onFieldChange, onFocusColumnSeparatorCustom = _a.onFocusColumnSeparatorCustom, onFocusRowSeparatorCustom = _a.onFocusRowSeparatorCustom, other = __rest(_a, ["values", "onFieldChange", "onFocusColumnSeparatorCustom", "onFocusRowSeparatorCustom"]);
    var classes = exports.useStyles();
    return (react_1.default.createElement("div", __assign({ className: classes.root }, other),
        react_1.default.createElement(core_1.Grid, { container: true, spacing: 2 },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 8 },
                react_1.default.createElement(core_1.FormControl, { component: "fieldset" },
                    react_1.default.createElement(core_1.FormLabel, { component: "legend" }, "Between term and definition"),
                    react_1.default.createElement(core_1.RadioGroup, { "aria-label": "Between term and definition", name: "columnSeparator", value: values.columnSeparator, onChange: onFieldChange },
                        react_1.default.createElement(core_1.FormControlLabel, { value: "tab", control: react_1.default.createElement(core_1.Radio, null), label: "Tab" }),
                        react_1.default.createElement(core_1.FormControlLabel, { value: "comma", control: react_1.default.createElement(core_1.Radio, null), label: "Comma" }),
                        react_1.default.createElement(core_1.FormControlLabel, { value: "custom", control: react_1.default.createElement(core_1.Radio, null), label: react_1.default.createElement(TextField_1.default, { className: classes.customTextField, helperText: "Custom", variant: "underlined", name: "columnSeparatorCustom", id: "columnSeparatorCustom-field", value: values.columnSeparatorCustom, onChange: onFieldChange, onFocus: onFocusColumnSeparatorCustom }) })))),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 4 },
                react_1.default.createElement(core_1.FormControl, { component: "fieldset" },
                    react_1.default.createElement(core_1.FormLabel, { component: "legend" }, "Between rows"),
                    react_1.default.createElement(core_1.RadioGroup, { "aria-label": "Between rows", name: "rowSeparator", value: values.rowSeparator, onChange: onFieldChange },
                        react_1.default.createElement(core_1.FormControlLabel, { value: "new-line", control: react_1.default.createElement(core_1.Radio, null), label: "New line" }),
                        react_1.default.createElement(core_1.FormControlLabel, { value: "semicolon", control: react_1.default.createElement(core_1.Radio, null), label: "Semicolon" }),
                        react_1.default.createElement(core_1.FormControlLabel, { value: "custom", control: react_1.default.createElement(core_1.Radio, null), label: react_1.default.createElement(TextField_1.default, { className: classes.customTextField, helperText: "Custom", variant: "underlined", name: "rowSeparatorCustom", id: "rowSeparatorCustom-field", value: values.rowSeparatorCustom, onChange: onFieldChange, onFocus: onFocusRowSeparatorCustom }) })))),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(core_1.FormControl, { fullWidth: true },
                    react_1.default.createElement(core_1.FormLabel, { component: "legend" }, "Paste the text from Quizlet below."),
                    react_1.default.createElement(TextField_1.default, { multiline: true, rows: 6, variant: "bordered", name: "text", id: "text-input", value: values.text, onChange: onFieldChange, InputBaseProps: {
                            className: classes.textarea,
                        } }))))));
};
exports.default = DeckImportFromQuizlet;
//# sourceMappingURL=DeckImportFromQuizlet.js.map